<script setup lang="ts">
import { generateColor } from 'frontend/chat/helpers'
import { computed } from 'vue'

interface Props {
  avatarUrl?: string
  initials?: string
  seed?: string
  alt?: string
}
const props = withDefaults(defineProps<Props>(), {
  avatarUrl: null,
  initials: null,
  seed: null,
  alt: null,
})

const userAvatarStyle = computed(() => {
  if (!props.initials || !props.seed) {
    return {}
  }
  return {
    background: generateColor(props.seed),
  }
})
</script>

<template>
  <div class="user-avatar" :style="userAvatarStyle">
    <img v-if="avatarUrl" :src="avatarUrl" :alt="alt" class="image" />
    <div class="initials" v-else-if="props.initials">{{ props.initials }}</div>
  </div>
</template>

<style scoped lang="scss">
@use 'sass:map';
@use 'frontend_stylesheets/theme-variables' as themeVariables;

.user-avatar {
  width: 32px;
  aspect-ratio: 1;
  background: map.get(themeVariables.$colors, containerHigh);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.initials {
  color: white;
}
</style>
